module.exports = __webpack_public_path__ + "static/media/dark-theme-utilization.a30b02a7.svg";